import React from "react";
import LegalLayout from "./LegalLayout";

export default function Contact() {
  return (
    <LegalLayout title="Contact & Support" effectiveDate="February 1, 2026">
      <p>We're a small team. Please email us and we'll do our best to respond within one business day.</p>

      <h2>General support</h2>
      <p><a href="mailto:support@homecostpath.com">support@homecostpath.com</a></p>

      <h2>Billing & refunds</h2>
      <p><a href="mailto:support@homecostpath.com">support@homecostpath.com</a> — please include the email address you used to purchase.</p>

      <h2>Privacy requests (CCPA/CPRA, GDPR, delete-my-data, etc.)</h2>
      <p><a href="mailto:support@homecostpath.com">support@homecostpath.com</a> with subject line "Privacy Request."</p>

      <h2>Security disclosures</h2>
      <p>If you believe you've found a security vulnerability, please email <a href="mailto:support@homecostpath.com">support@homecostpath.com</a> with subject line "Security" and include enough detail for us to reproduce the issue. We appreciate responsible disclosure.</p>

      <h2>Company</h2>
      <p>Home Cost Path is a product of <b>TaskHive LLC</b>.</p>
    </LegalLayout>
  );
}
